import axios, { AxiosRequestConfig } from 'axios'
import { isNil } from 'lodash'
import {
  CreateBusinessEntityRequestDto,
  CreateBusinessEntityResponseDto,
  GetBusinessEntityDetailsRequestDto,
  GetBusinessEntityDetailsResponseDto,
  ReadBusinessEntitiesForAssignUserRequestDto,
  ReadBusinessEntitiesForAssignToUserResponseDto,
  GetUsersForAssignEntityRequestDto,
  GetUsersForAssignEntityResponseDto,
  ReadBusinessEntitiesRequestDto,
  ReadBusinessEntitiesResponseDto,
  UpdateBusinessEntityDetailsRequestDto,
  UpdateBusinessEntitySettingsRequestDto,
  UpdateBusinessEntityUsersRequestDto,
  DeleteBusinessEntityUserRequestDto,
} from '@sparling/financial-common'

export const fetchBusinessEntities = async (
  { token, ...params }: ReadBusinessEntitiesRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<ReadBusinessEntitiesResponseDto> => {
  const response = await axios.get<ReadBusinessEntitiesResponseDto>(`${process.env.REACT_APP_SERVER_URL}/crm/entity`, {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    params: Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== '')),
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  })
  return response.data
}

export const getBusinessEntityDetails = async (
  { token, id, ...params }: { id: string } & GetBusinessEntityDetailsRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<GetBusinessEntityDetailsResponseDto> => {
  const response = await axios.get<GetBusinessEntityDetailsResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/entity/${id}`,
    {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      params: Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== '')),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const createBusinessEntity = async (
  { token, ...data }: CreateBusinessEntityRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<CreateBusinessEntityResponseDto> => {
  const response = await axios.post<CreateBusinessEntityResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/entity`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const updateBusinessEntityDetails = async (
  { token, id, ...data }: { id: string } & UpdateBusinessEntityDetailsRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<GetBusinessEntityDetailsResponseDto> => {
  const response = await axios.patch<GetBusinessEntityDetailsResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/entity/${id}/details`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const updateBusinessEntityUsers = async (
  { token, id, ...data }: { id: string } & UpdateBusinessEntityUsersRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<GetBusinessEntityDetailsResponseDto> => {
  const response = await axios.patch<GetBusinessEntityDetailsResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/entity/${id}/users`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const deleteBusinessEntityUsers = async (
  { token, id, ...data }: { id: string } & DeleteBusinessEntityUserRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<GetBusinessEntityDetailsResponseDto> => {
  const response = await axios.patch<GetBusinessEntityDetailsResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/entity/${id}/remove-user`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const updateBusinessEntitySettings = async (
  { token, id, ...data }: { id: string } & UpdateBusinessEntitySettingsRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<GetBusinessEntityDetailsResponseDto> => {
  const response = await axios.patch<GetBusinessEntityDetailsResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/entity/${id}/settings`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const fetchUsersForAssignEntity = async (
  { token, ...params }: GetUsersForAssignEntityRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<GetUsersForAssignEntityResponseDto> => {
  const response = await axios.get<GetUsersForAssignEntityResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/users-for-assign-entity`,
    {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      params: Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== '')),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const fetchBusinessEntitiesForAssignToUser = async (
  { token, ...params }: ReadBusinessEntitiesForAssignUserRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<ReadBusinessEntitiesForAssignToUserResponseDto> => {
  const response = await axios.get<ReadBusinessEntitiesForAssignToUserResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/entity/entity-for-assign-to-users`,
    {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      params: Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== '')),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}
